import { getRequiredEnv } from '@/utils/get-required-env';
import { LPPSApi } from './apis';
import { getMiddlewares } from './middlewares';
import {
  type TokenGetter,
  createAuthMiddleware,
} from './middlewares/auth-middleware';
import { Configuration, ConfigurationParameters } from './runtime';

let apiClient: LPPSApi;

export const getApiClient = (): LPPSApi => {
  if (!apiClient) {
    throw new Error(
      'API client not initialized! Make sure `initApiClient` is called before using the API client.',
    );
  }
  return apiClient;
};

export const initApiClient = async (accessToken: TokenGetter): Promise<void> => {
  const configParams: ConfigurationParameters = {
    basePath: getRequiredEnv('VITE_BACKEND_URL'),
    // The auth middleware must run first so its `post` step can retry a 401
    // before the error middleware turns the response into an ApiError.
    middleware: [createAuthMiddleware(accessToken), ...getMiddlewares()],
  };
  const config = new Configuration(configParams);

  apiClient = new LPPSApi(config);
};
